import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=3a614273"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=3a614273&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a614273')) {
      api.createRecord('3a614273', component.options)
    } else {
      api.reload('3a614273', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=3a614273", function () {
      api.rerender('3a614273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/label/hand/components/DataForm.vue"
export default component.exports